import React from 'react'
import Card from './Card'
import Navbar from './Navbar'
const App = () => {
  return (
    <div>
       <Navbar/> 
      <Card/>
    </div>
  )
}

export default App
